import React from 'react';

import SelectionTextBox from './SelectionTextBox.js';
import {PropertyFilter} from './Filter.js';
import './FilterWidget.css';


class FilterWidget extends React.Component {
    constructor(props) {
        super(props);

        this.partitionClick = this.partitionClick.bind(this);
    }

    partitionClick(event) {
        const clicked_part = event.target.childNodes[0].textContent;
        const filter = this.props['filters']['partition'];

        this.props['onfilterchange']({'partition': filter.togglePartition(clicked_part)});
    }

    filterSuggestions(entered_txt) {
        const parsed = PropertyFilter.getPossibilities(entered_txt, this.props['units'], this.props['allow_states']);

        let suggestions;
        if (typeof parsed['vars'] === 'object') {
            suggestions = parsed['vars'];
        }
        else if (typeof parsed['ops'] === 'object') {
            suggestions = parsed['ops'];
        }
        else {
            suggestions = parsed['val'];
        }
        suggestions['autocomplete'] = parsed['autocomplete'];
        suggestions['maybe_complete'] = parsed['maybe_complete'];
        return suggestions;
    }

    filterParse(filter_str) {
        return PropertyFilter.fromString(filter_str, this.props['units'], this.props['allow_states']);
    }

    filterSearch(filters) {
        let filter_obj = Object.fromEntries(Object.keys(this.props['filters'])
            .filter(f => f != 'partition')
            .map(f => [f, null]));

        filters.forEach(filt => {
            filter_obj[filt.variable] = filt;
        });

        this.props['onfilterchange'](filter_obj);
    }

    ondomainchange() {
        if (this.props['ondomainchange'] !== undefined) {
            const dom_value = document.getElementById('domain-control').value;
            this.props['ondomainchange'](dom_value);
        }
    }

    render() {
        const part_filter = this.props['filters']['partition'];

        const width = Math.min(800, (this.props['width'] - 520) * 0.8);
        const filters = Object.values(this.props['filters']).filter(f => f.display(this.props['units']) !== null);

        return (
            <div id='filter-controls'>
                <div className='control'>
                    Domain:&nbsp;
                    <select 
                        id='domain-control'
                        defaultValue={this.props['sel_domain']}
                        onChange={this.ondomainchange.bind(this)}>
                        {
                            this.props['domains'].map(dom_name => {
                                return <option key={dom_name}>{dom_name}</option>
                            })
                        }
                    </select>
                </div>
                <div className='control'>
                    <ul id='partition-control'>
                        {part_filter.part.label_str}:
                        {
                            part_filter.part.part_keys.map(k => {
                                return <li key={k} style={part_filter.getPartDisplayStyle(k)} onClick={this.partitionClick}>{k}</li>
                            })
                        }
                    </ul>
                </div>
                <div className='control'>
                    Filters:&nbsp;
                    <SelectionTextBox
                        content={filters}
                        placeholder={'e.g., ' + this.props['example']}
                        onselectionupdate={this.filterSearch.bind(this)}
                        parser={this.filterParse.bind(this)}
                        width={width}
                        suggestion_callback={this.filterSuggestions.bind(this)}
                        max_selections={10}
                        display_args={[this.props['units']]}
                    />
                </div>
            </div>
        );
    }
}

export default FilterWidget;